import { handleActions } from 'redux-actions'
import actions from '~/actions'
import { parseAddress } from '~/utils'

const initialState = {
  permission: null,
  user: {},
  fetched: false,
  showMapPlaceholder: true,
  customLocation: null,
  showPositionDialog: false,
}

const reducer = handleActions(
  {
    [actions.position.change]: (state, { payload }) => ({
      ...state,
      ...payload,
      user: payload?.user && Object.keys(payload.user) ? parseAddress(payload.user) : state.user,
    }),
    [actions.position.updatePermission]: (state, { payload }) => ({
      ...state,
      permission: payload,
    }),
  },
  initialState,
)

export default reducer
